// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RestTwoToneSvg from "@fishx/icons-svg/es/asn/RestTwoTone";
import FishxIcon from '../components/FishxIcon';

var RestTwoTone = function RestTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RestTwoToneSvg
  }));
};

RestTwoTone.displayName = 'RestTwoTone';
export default React.forwardRef(RestTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RestTwoTone.js
// module id = 4003
// module chunks = 0